import React, { useState } from 'react'
import { Form, Input, Row, Col, Divider, DatePicker, Button, notification, Upload, Alert, Card } from 'antd'
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, SelectOutlined } from '@ant-design/icons';
import { useParams , useHistory } from 'react-router-dom'
import AppService from 'services/AppService';
import { useEffect } from 'react';
import moment from 'moment'
import { connect } from 'react-redux';
import { motion } from "framer-motion"
import { FaLinkedinIn } from 'react-icons/fa'
import {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
} from 'redux/actions/Auth';
import { API_BASE_URL } from 'configs/AppConfig';
import EducationAddFields from '../jobrole/components/EducationAddFields';
import ExperienceAddFields from '../jobrole/components/ExperienceAddFields';

function EditEducation(props) {
    const {  showAuthMessage, hideAuthMessage, showMessage, getProfile } = props
    const [filelist, setFilelist] = useState([])
    const [filelist2, setFilelist2] = useState([])
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const { id } = useParams()
    const history = useHistory();

    const handleFinish = (values) => {
        setLoading(true)

        const formdata = new FormData()
        formdata.append('education', values.education ? JSON.stringify(values.education) : '')

        AppService.updateProfile({data: formdata, type: 'education'}).then(resp => {
            notification.success({
                message: resp
            })
            getProfile()
            fetchProfile()
            setLoading(false)
        }).catch(e => {
            showAuthMessage(e.response.data)
            setLoading(false)
        })

    }
    const fetchProfile = () =>{
        AppService.fetchProfile().then(resp => {
            const { birthDate, education, experienceDetails, resume, profileImg, ...rest } = resp
            resume && setFilelist(
                [
                    {
                        uid: '-1',
                        name: `${resume}`,
                        status: 'done',

                    }
                ]
            )
            profileImg && setFilelist2(
                [
                    {
                        uid: '-1',
                        name: `${profileImg}`,
                        status: 'done',
                        url: `${API_BASE_URL}/image/profile/${profileImg}`,
                    }
                ]
            )
            form.setFieldsValue({
                ...rest,
                birthDate: moment(birthDate),
                education: education.map(e => {
                    return {
                        ...e,
                        joiningDate: moment(e.joiningDate),
                        passoutDate: moment(e.passoutDate)
                    }
                }),
                experienceDetails: experienceDetails.map(e => {
                    return {
                        ...e,
                        joiningDate: moment(e.joiningDate),
                        relievingDate: moment(e.relievingDate)
                    }
                })
            })
           
        }).catch(e => notification.error({
            message: 'Oops! Unable to fetch Profile. '
        }))
    }

    useEffect(() => {
        props.setLogo("/img/logo.png")
        props.setLogoActive(true)
        fetchProfile()
    }, [])

    useEffect(() => {
        if (showMessage) {
            setTimeout(() => {
                hideAuthMessage()
            }, 3000)
        }
    })
    return (
        <div className='main'>
        <div className='container'>
           <Row>
    <Col span={24}>
        <Button 
            style={{backgroundColor:'#1677ff',color:'#fff', marginBottom: '20px'}} 
            icon={<SelectOutlined className="mb-3" size={20} />} 
            onClick={() => history.push("/app/profile/edit")}
            >
            Go Back
        </Button>
    </Col>
</Row>
  <Card style={{padding:"20px 2%"}}>
  <div className='settings-page-heading'>
    <h1>
    Education Details
    </h1>
  </div>
  
  <Divider></Divider>
  <Form
                    form={form}
                    onFinish={handleFinish}
                    layout='vertical'
                    className='mt-5'>
                    <Form.List name="education">
                        {(fields, { add, remove }) => {
                            return (
                                <div>
                                    {fields.map((field, index) => (
                                        <EducationAddFields form={form} field={field} remove={remove} key={index} index={index} />
                                    ))}
                                    <Form.Item
                                        rules={[
                                            {
                                            }

                                        ]}
                                    >
                                        <Button
                                            className='w-100'
                                            type="dashed"
                                            onClick={() => {
                                                add();
                                            }}

                                        >
                                            <PlusOutlined /> Add field
                                        </Button>
                                    </Form.Item>
                                </div>
                            );
                        }}
                    </Form.List>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Update
                    </Button>
                </Form>
               </Card>
           </div>
        </div>
    )
}
const mapStateToProps = ({ auth }) => {
    const { message, showMessage } = auth
    return { message, showMessage }
}
const mapDispatchToProps = {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
}


export default connect(mapStateToProps, mapDispatchToProps)(EditEducation)


// import React, { useState } from 'react'
// import { Form, Input, Row, Col, Divider, DatePicker, Button, notification, Upload, Alert, Card } from 'antd'
// import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
// import { useParams } from 'react-router-dom'
// import AppService from 'services/AppService';
// import { useEffect } from 'react';
// import moment from 'moment'
// import { connect } from 'react-redux';
// import { motion } from "framer-motion"
// import { FaLinkedinIn } from 'react-icons/fa'
// import {
//     showAuthMessage,
//     hideAuthMessage,
//     getProfile,
//     setLogo,
//     setLogoActive
// } from 'redux/actions/Auth';
// import Flex from 'components/shared-components/Flex';
// import { API_BASE_URL } from 'configs/AppConfig';
// import EducationAddFields from '../jobrole/components/EducationAddFields';
// import ExperienceAddFields from '../jobrole/components/ExperienceAddFields';

// function Profile(props) {
//     const { message, showAuthMessage, hideAuthMessage, showMessage, getProfile } = props
//     const [filelist, setFilelist] = useState([])
//     const [filelist2, setFilelist2] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [form] = Form.useForm()
//     const { id } = useParams()
//     const [isChangeEmail, setIsChangeEmail] = useState(false);
//     const [emailLoading, setEmailLoading] = useState(false)

//     const options = {
//         onRemove: file => {
//             const index = filelist.indexOf(file)
//             const newFileList = filelist.slice()
//             newFileList.splice(index, 1)
//             setFilelist(newFileList)
//         },
//         beforeUpload: file => {

//             setFilelist([file])
//             return false
//         }
//     }
//     const options2 = {
//         // onRemove: file => {
//         //     console.log(filelist)
//         //     const index = filelist.indexOf(file)
//         //     const newFileList = filelist.slice()
//         //     newFileList.splice(index, 1)
//         //     console.log(newFileList)
//         //     setFilelist(newFileList)
//         // },
//         // previewFile:(file)=>{
//         //    console.log(file)
//         // },
//         beforeUpload: async file => {

//             // let src = await new Promise(resolve => {
//             //     const reader = new FileReader();
//             //     reader.readAsDataURL(file.originFileObj)
//             //     reader.onload = () => resolve(reader.result);
//             // })



//             return false
//         },
//         onChange: async ({ fileList: newFileList }) => {
//             // console.log(newFileList)
//             const temp = newFileList.length - 1 >= 0 ? [newFileList[newFileList.length - 1]] : []

//             let file = newFileList[newFileList.length - 1]
//             // console.log(file)
//             if (file) {
//                 let src = await new Promise(resolve => {
//                     const reader = new FileReader();
//                     reader.readAsDataURL(file.originFileObj);
//                     reader.onload = () => resolve(reader.result);
//                 });
//                 const image = new Image();

//                 image.src = src
//                 // console.log(image,src)
//                 // console.log(image.width,image.height)
//                 image.onload = function () {
//                     if (false) {
//                         showAuthMessage(
//                             "Image must be square."
//                         )
//                     } else {
//                         setFilelist2(temp);
//                     }

//                 }


//             } else {
//                 setFilelist2(temp);
//             }



//         },

//         onPreview: async file => {
//             let src = file.url;
//             if (!src) {
//                 src = await new Promise(resolve => {
//                     const reader = new FileReader();
//                     reader.readAsDataURL(file.originFileObj);
//                     reader.onload = () => resolve(reader.result);
//                 });
//             }
//             const image = new Image();
//             image.src = src;
//             const imgWindow = window.open(src);
//             imgWindow.document.write(image.outerHTML);
//         }
//     }
//     const handleFinish = (values) => {
//         setLoading(true)


//         const formdata = new FormData()
//         formdata.append('linkedin', values?.linkedin ? values?.linkedin : '')
//         formdata.append('firstName', values.firstName ? values.firstName : '')
//         formdata.append('lastName', values.lastName ? values.lastName : '')
//         formdata.append('mobileNo', values.mobileNo ? values.mobileNo : '')
//         formdata.append('birthDate', values.birthDate ? values.birthDate : '')
//         formdata.append('experience', values.experience ? values.experience : '')
//         formdata.append('address', values.address ? values.address : '')
//         formdata.append('city', values.city ? values.city : '')
//         formdata.append('pincode', values.pincode ? values.pincode : '')
//         formdata.append('state', values.state ? values.state : '')
//         formdata.append('education', values?.education ? JSON.stringify(values.education) : '[]')
//         formdata.append('resume', values.resume?.file?values.resume?.file:'')
//         formdata.append('profileImg', values.profileImg?.file?values.profileImg?.file:'')
//         formdata.append('hobbies',values.hobbies? values.hobbies : '')
//         AppService.updateProfile(id, formdata).then(resp => {

//             notification.success({
//                 message: "Profile updated successfully."
//             })
//             getProfile()
//             fetchProfile()
//             setLoading(false)
//         }).catch(e => {
//             showAuthMessage(e.response.data)
//             setLoading(false)
//         })

//     }
//     // function disabledDate(current) {
//     //     // Can not select days before today and today
//     //     return current && current.valueOf() > moment("01:12:2002");
//     //   }
//     const fetchProfile = () =>{
//         AppService.fetchProfile().then(resp => {
//             // console.log(resp)
//             const { birthDate, education, experienceDetails, resume, profileImg, ...rest } = resp
//             resume && setFilelist(
//                 [
//                     {
//                         uid: '-1',
//                         name: `${resume}`,
//                         status: 'done',

//                     }
//                 ]
//             )
//             profileImg && setFilelist2(
//                 [
//                     {
//                         uid: '-1',
//                         name: `${profileImg}`,
//                         status: 'done',
//                         url: `${API_BASE_URL}/image/profile/${profileImg}`,
//                     }
//                 ]
//             )
//             form.setFieldsValue({
//                 ...rest,
//                 birthDate: moment(birthDate),
//                 education: education.map(e => {
//                     return {
//                         ...e,
//                         joiningDate: moment(e.joiningDate),
//                         passoutDate: moment(e.passoutDate)
//                     }
//                 }),
//                 experienceDetails: experienceDetails.map(e => {
//                     return {
//                         ...e,
//                         joiningDate: moment(e.joiningDate),
//                         relievingDate: moment(e.relievingDate)
//                     }
//                 })
//             })
           
//         }).catch(e => notification.error({
//             message: 'Oops! Unable to fetch Profile. '
//         }))
//     }

//     const handleEmailChange = async () => {
//         try{
//             setEmailLoading(true)
//             const resp = await AppService.updateCandidateEmail({id, email: form.getFieldValue('email')})
//             // console.log(resp)
//             notification.success({message: resp})
//             setEmailLoading(false)
//         }catch(err) {
//             setEmailLoading(false)
//             if(err.response.status === 500) {
//                 notification.error({message: err.response.data})
//             }else {
//                 notification.warning({message: err.response.data})
//             }
            
//         }
//     }

//     useEffect(() => {
//         props.setLogo("/img/logo.png")
//         props.setLogoActive(true)
//         fetchProfile()
       
//     }, [])

//     useEffect(() => {
//         if (showMessage) {
//             setTimeout(() => {
//                 hideAuthMessage()
//             }, 3000)
//         }
//     })
//     return (
//         <div className='main'>
//             <div className='container'>
//                <Card>
//                 <Form
//                     form={form}
//                     onFinish={handleFinish}
//                     layout='vertical'
//                     className='mt-5'>
//                     <Divider orientation="left">Basic Information</Divider>
//                     <Row gutter={8}>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="firstName" label="First Name"  >
//                                 <Input placeholder='First Name'>
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="lastName" label="Last Name"  >
//                                 <Input placeholder='Last name'>
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="mobileNo" label="Phone Number" rules={[
//                                 () => ({
//                                     validator(rule, value) {

//                                         const reg = /^[0-9]*$/;
//                                         if (reg.test(value)) {
//                                             return Promise.resolve();
//                                         }
//                                         return Promise.reject("Phone no must be digit ")
//                                     },
//                                 }),
//                             ]}  >
//                                 <Input placeholder='Phone Number' type="tel" maxLength={10}>
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Row gutter={10}>
//                                 <Col span={18}>
//                                     <Form.Item name="email" label="Email">
//                                         <Input placeholder='Email' type='email' disabled={!isChangeEmail} />
//                                     </Form.Item>
//                                 </Col>
//                                 <Col span={6}>
//                                     <Form.Item label=" ">
//                                         {
//                                             isChangeEmail ?
//                                             <Button type='primary' loading={emailLoading} onClick={handleEmailChange}>Change</Button>
//                                             :
//                                             <Button type='primary' onClick={() => setIsChangeEmail(true)}>Change</Button>
//                                         }
//                                     </Form.Item>
//                                 </Col>
//                             </Row>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="birthDate" label="Birth Date"  >
//                                 <DatePicker className='w-100'  placeholder='Birth Date' >
//                                 </DatePicker>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="experience" label="Experience (In Years)" initialValue={0} min='0' max="50"  >
//                                 <Input type="number" placeholder='Experience' >
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="linkedin" label="Linkedin Profile" >
//                                 <Input addonBefore={<FaLinkedinIn />} type='url'></Input>
//                             </Form.Item>
//                         </Col>
//                         <Col xl={8} lg={12} span={24}>
//                             <Form.Item name="hobbies" label="Hobbies"  >
//                                 <Input placeholder='Hobbies' >
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                     </Row>
//                     <Divider orientation="left">Address Information</Divider>
//                     <Row gutter={8}>
//                         <Col md={12} sm={24} xs={24} >
//                             <Form.Item name="address" label="Address"  >
//                                 <Input placeholder='Address'>
//                                 </Input>
//                             </Form.Item>

//                         </Col>
//                         <Col md={4} sm={12} xs={24}>
//                             <Form.Item name="state" label="State"  >
//                                 <Input placeholder='State'>
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col md={4} sm={12} xs={24}>
//                             <Form.Item name="city" label="City"  >
//                                 <Input placeholder='City'>
//                                 </Input>
//                             </Form.Item>
//                         </Col>
//                         <Col md={4} sm={12} xs={24}>
//                             <Form.Item name="pincode" label="PinCode" rules={[() => ({
//                                 validator(rule, value) {

//                                     const reg = /^[0-9]*$/;
//                                     if (reg.test(value)) {
//                                         return Promise.resolve();
//                                     }
//                                     return Promise.reject("Pincode must be digit ")
//                                 },
//                             }),]}>
//                                 <Input type="tel" placeholder='Pincode' maxLength={10}>
//                                 </Input>
//                             </Form.Item>
//                         </Col>

//                     </Row>
//                     <Divider orientation="left">Education Details</Divider>
//                     <Form.List name="education">
//                         {(fields, { add, remove }) => {
//                             return (
//                                 <div>
//                                     {fields.map((field, index) => (
//                                         <EducationAddFields form={form} field={field} remove={remove} key={index} />
//                                     ))}
//                                     <Form.Item
//                                         rules={[
//                                             {
//                                             }

//                                         ]}
//                                     >
//                                         <Button
//                                             className='w-100'
//                                             type="dashed"
//                                             onClick={() => {
//                                                 add();
//                                             }}

//                                         >
//                                             <PlusOutlined /> Add field
//                                         </Button>
//                                     </Form.Item>
//                                 </div>
//                             );
//                         }}
//                     </Form.List>
//                     <Divider orientation="left">Experience Details</Divider>
//                     <Form.List name="experienceDetails">
//                         {(fields, { add, remove }) => {
//                             return (
//                                 <div>
//                                     {fields.map((field, index) => (

//                                         <ExperienceAddFields field={field} form={form} remove={remove} key={index} />

//                                     ))}
//                                     <Form.Item
//                                         rules={[
//                                             {
//                                                 required: true
//                                             }

//                                         ]}
//                                     >
//                                         <Button
//                                             className='w-100'
//                                             type="dashed"
//                                             onClick={() => {
//                                                 add();
//                                             }}

//                                         >
//                                             <PlusOutlined /> Add field
//                                         </Button>
//                                     </Form.Item>
//                                 </div>
//                             );
//                         }}
//                     </Form.List>
//                    <Divider orientation="left">Upload files</Divider>
//                      {/* <Form.List name="experienceDetails">
//                         {(fields, { add, remove }) => {
//                             return (
//                                 <div>
//                                     {fields.map((field, index) => (

//                                         <>
//                                             <Flex justifyContent='end'>
//                                                 <MinusCircleOutlined

//                                                     style={{ fontSize: '20px', color: 'red' }}
//                                                     className="dynamic-delete-button"
//                                                     onClick={() => {
//                                                         remove(field.name);
//                                                     }}
//                                                 />

//                                             </Flex>


//                                             <Row gutter={8} >
//                                                 <Col md={8}>
//                                                     <Form.Item
//                                                         {...field}

//                                                         name={[field.name, 'companyName']}
//                                                         label="Company name"
//                                                         validateTrigger={['onChange', 'onBlur']}
//                                                         rules={[
//                                                             {

//                                                                 whitespace: true
//                                                             },
//                                                         ]}

//                                                     >
//                                                         <Input placeholder="Comapany name" />
//                                                     </Form.Item>
//                                                 </Col>
//                                                 <Col md={8}>
//                                                     <Form.Item
//                                                         {...field}
//                                                         name={[field.name, 'desig']}
//                                                         label="Designation"
//                                                         validateTrigger={['onChange', 'onBlur']}
//                                                         rules={[
//                                                             {

//                                                                 whitespace: true
//                                                             },
//                                                         ]}

//                                                     >
//                                                         <Input placeholder="Designation" />
//                                                     </Form.Item>
//                                                 </Col>
//                                                 <Col md={8}>
//                                                     <Form.Item
//                                                         {...field}
//                                                         name={[field.name, 'joiningDate']}
//                                                         label="Joining date"



//                                                     >
//                                                         <DatePicker placeholder="Joining Date" />
//                                                     </Form.Item>
//                                                 </Col>
//                                                 <Col md={8}>
//                                                     <Form.Item
//                                                         {...field}
//                                                         name={[field.name, 'relievingDate']}
//                                                         label="Relieving date" >
//                                                         <DatePicker placeholder="Relieving Date" />
//                                                     </Form.Item>
//                                                 </Col>


//                                             </Row>



//                                         </>



//                                     ))}
//                                     <Form.Item

//                                     >
//                                         <Button
//                                             type="dashed"
//                                             onClick={() => {
//                                                 add();
//                                             }}

//                                         >
//                                             <PlusOutlined /> Add field
//                                         </Button>
//                                     </Form.Item>
//                                 </div>
//                             );
//                         }}


//                     </Form.List> */}
//                     <Form.Item
//                         name="resume"
//                         label="Upload resume"
//                         style={{ width: '320px' }}
//                         extra="Accepted file types : pdf, docx. Max file size 5Mb."
//                     >

//                         <Upload {...options} fileList={filelist} accept='.pdf, .docx' >
//                             <Button>
//                                 <UploadOutlined /> Select File
//                             </Button>
//                         </Upload>
//                     </Form.Item>
//                     <Form.Item
//                         name="profileImg"
//                         label="Upload profile img"
//                         style={{ width: '320px' }}
//                         extra="Accepted file types : png, jpeg, jpg. Max file size 5Mb."
//                     >

//                         <Upload {...options2} listType='picture-card' fileList={filelist2} accept='.jpg,.jpeg,.png' >

//                             <UploadOutlined />  <span className='ml-2'>Change</span>

//                         </Upload>
//                     </Form.Item>
//                     <motion.div
//                         initial={{ opacity: 0, marginBottom: 0 }}
//                         animate={{
//                             opacity: showMessage ? 1 : 0,
//                             marginBottom: showMessage ? 20 : 0
//                         }}>
//                         <Alert type="error" showIcon message={message}></Alert>
//                     </motion.div>

//                     <Button type="primary" htmlType="submit" loading={loading}>
//                         Update
//                     </Button>




//                 </Form>
//                </Card>
//            </div>
//         </div>
//     )
// }
// const mapStateToProps = ({ auth }) => {
//     const { message, showMessage } = auth
//     return { message, showMessage }
// }
// const mapDispatchToProps = {
//     showAuthMessage,
//     hideAuthMessage,
//     getProfile,
//     setLogo,
//     setLogoActive
// }


// export default connect(mapStateToProps, mapDispatchToProps)(Profile)
